import { render, staticRenderFns } from "./recordDownload.vue?vue&type=template&id=53735822&"
import script from "./recordDownload.vue?vue&type=script&lang=js&"
export * from "./recordDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports